import mixpanel from 'mixpanel-browser';
import { isDev, isStaging } from '@/env';
import { throttleFn } from './utils';

export const PageViewEventName = {
  view_channel_createdgames: 'view_channel_createdgames',
  view_channel_feed: 'view_channel_feed',
  view_dashboard: 'view_dashboard',
  view_gamesetting: 'view_gamesetting',
  view_releasemanage: 'view_releasemanage',
  view_communitymanage: 'view_communitymanage',
  view_landing: 'view_landing',
  view_community: 'view_community',
  view_channel_setting: 'view_channel_setting',
  view_createnewgame: 'view_createnewgame',
  view_editgame_edittheme: 'view_editgame_edittheme',
  view_editgame_editmission: 'view_editgame_editmission',
  view_editgame_editmission_quest: 'view_editgame_editmission_quest',
  view_editgame_edititem: 'view_editgame_edititem',
  view_editgame_editchatbot: 'view_editgame_editchatbot',
  view_editgame_filestorage: 'view_editgame_filestorage',
  view_agreetermpage: 'view_agreetermpage',
  view_verifycontact: 'view_verifycontact',
  view_welcomestudiopage: 'view_welcomestudiopage',
  view_onboardingpage: 'view_onboardingpage',
  view_newchannelpage: 'view_newchannelpage',
  view_newgame_ai_storyconfig: 'view_newgame_ai_storyconfig',
  view_newgame_ai_storyconfig_error: 'view_newgame_ai_storyconfig_error',
  view_newgame_ai_storyconfig_refresh: 'view_newgame_ai_storyconfig_refresh',
  view_newgame_ai_storyconfirm: 'view_newgame_ai_storyconfirm',
  view_newgame_ai_styleconfig: 'view_newgame_ai_styleconfig',
  view_newgame_ai_exit_modal: 'view_newgame_ai_exit_modal',
  view_editgame_modal_aigenerate_image: 'view_editgame_modal_aigenerate_image',
  view_editgame_modal_aigenerate_bgm: 'view_editgame_modal_aigenerate_bgm',
  view_landing_plan: 'view_landing_plan',
  view_landing_service_info: 'view_landing_service_info',
  view_plan_enterprise_form: 'view_plan_enterprise_form',
  view_plan_enterprise_form_submit_success: 'view_plan_enterprise_form_submit_success',
  view_plan_pro_channel_select: 'view_plan_pro_channel_select',
  view_setting_channel: 'view_setting_channel',
  view_setting_member: 'view_setting_member',
  view_setting_plan: 'view_setting_plan',
  view_setting_donation: 'view_setting_donation',
  view_plan_promotion_modal: 'view_plan_promotion_modal',
  view_plan_modal_concurrent_session_existing: 'view_plan_modal_concurrent_session_existing',
  view_plan_modal_concurrent_session_incoming: 'view_plan_modal_concurrent_session_incoming'
} as const;
export type PageViewEventName = typeof PageViewEventName[keyof typeof PageViewEventName];

export const ClickEventName = {
  click_editgame_theme_select_lightordark: 'click_editgame_theme_select_lightordark',
  click_editgame_theme_delete_horizontalimage: 'click_editgame_theme_delete_horizontalimage',
  click_editgame_theme_delete_verticallimage: 'click_editgame_theme_delete_verticallimage',
  click_editgame_theme_input_imagesearch: 'click_editgame_theme_input_imagesearch',
  click_editgame_theme_backgroundimage_gamebackgroundimage_input_searchimage:
    'click_editgame_theme_backgroundimage_gamebackgroundimage_input_searchimage',
  click_editgame_theme_backgroundimage_missionbackgroundimage_input_searchimage:
    'click_editgame_theme_backgroundimage_missionbackgroundimage_input_searchimage',
  click_editgame_mission_landingpopup_close: 'click_editgame_mission_landingpopup_close',
  click_editgame_mission_landingpopup_createmission:
    'click_editgame_mission_landingpopup_createmission',
  click_editgame_mission_new_mission: 'click_editgame_mission_new_mission',
  click_editgame_mission_quest_webviewbuilder: 'click_editgame_editmission_quest_webviewbuilder',
  click_editgame_mission_quest_webviewbuilder_close:
    'click_editgame_mission_quest_webviewbuilder_close',
  click_editgame_mission_quest_webviewbuilder_template:
    'click_editgame_mission_quest_webviewbuilder_template',
  click_editgame_mission_quest_webviewbuilder_template_exit:
    'click_editgame_mission_quest_webviewbuilder_template_exit',
  click_editgame_mission_quest_webviewbuilder_notapply:
    'click_editgame_mission_quest_webviewbuilder_notapply',
  click_editgame_mission_item_close: 'click_editgame_mission_item_close',
  click_editgmae_mission_item_createitem: 'click_editgmae_mission_item_createitem',
  click_editgame_mission_item_newitem: 'click_editgame_mission_item_newitem',
  click_editgame_mission_chatbot_close: 'click_editgame_mission_chatbot_close',
  click_editgame_mission_chatbot_createchatbot: 'click_editgame_mission_chatbot_createchatbot',
  click_editgame_mission_chatbot_newchatbot: 'click_editgame_mission_chatbot_newchatbot',
  click_editgame_mission_file_newfolder: 'click_editgame_mission_file_newfolder',
  click_landing_button_startnow: 'click_landing_button_startnow',
  click_landing_button_startfree: 'click_landing_button_startfree',
  click_landing_button_makegame: 'click_landing_button_makegame',
  click_landing_button_exploregame: 'click_landing_button_exploregame',
  click_landing_button_challangecreator: 'click_landing_button_challangecreator',
  click_landing_menu_contest: 'click_landing_menu_contest',
  click_landing_menu_community: 'click_landing_menu_community',
  click_landing_menu_helpcenter: 'click_landing_menu_helpcenter',
  click_landing_footer_updates: 'click_landing_footer_updates',
  click_landing_footer_community: 'click_landing_footer_community',
  click_landing_footer_helpcenter: 'click_landing_footer_helpcenter',
  click_channel_input_feed: 'click_channel_input_feed',
  click_channel_input_community: 'click_channel_input_community',
  click_channel_button_creategame: 'click_channel_button_creategame',
  click_channel_button_settings: 'click_channel_button_settings',
  click_newgame_select_notemplate: 'click_newgame_select_notemplate',
  click_newgame_select_template: 'click_newgame_select_template',
  click_newgame_button_templatedetail: 'click_newgame_button_templatedetail',
  click_newgame_button_relativegame: 'click_newgame_button_relativegame',
  click_newgame_button_selecttemplate: 'click_newgame_button_selecttemplate',
  click_newgame_button_creategame: 'click_newgame_button_creategame',
  click_dashboard_input_daterange: 'click_dashboard_input_daterange',
  click_dashboard_button_download: 'click_dashboard_button_download',
  click_gamesetting_basicinformation_button_gametype:
    'click_gamesetting_basicinformation_button_gametype',
  click_gamesetting_basicinformation_button_gamekit:
    'click_gamesetting_basicinformation_button_gamekit',
  click_gamesetting_basicinformation_button_genre:
    'click_gamesetting_basicinformation_button_genre',
  click_gamesetting_basicinformation_button_playtime:
    'click_gamesetting_basicinformation_button_playtime',
  click_gamesetting_basicinformation_button_difficulty:
    'click_gamesetting_basicinformation_button_difficulty',
  click_gamesetting_unlockcode_button_makeunlockcode:
    'click_gamesetting_unlockcode_button_makeunlockcode',
  click_gamesetting_deleteplayhistory_button_delete:
    'click_gamesetting_deleteplayhistory_button_delete',
  click_releasemanage_select_openornot: 'click_releasemanage_select_openornot',
  click_releasemanage_salesetting_select_price: 'click_releasemanage_salesetting_select_price',
  click_agreetermpage_agree: 'click_agreetermpage_agree',
  click_verifycontactpage_button_check: 'click_verifycontactpage_button_check',
  click_verifycontactpage_button_checkstatus: 'click_verifycontactpage_button_checkstatus',
  click_verifycontactpage_button_registercreatercomplete:
    'click_verifycontactpage_button_registercreatercomplete',
  click_onboardingpage_button_personal: 'click_onboardingpage_button_personal',
  click_onboardingpage_button_biz: 'click_onboardingpage_button_biz',
  click_onboardingpage_button_next: 'click_onboardingpage_button_next',
  click_newchannelpage_button_start: 'click_newchannelpage_button_start',
  click_newchannelpage_button_gotochannel: 'click_newchannelpage_button_gotochannel',
  click_main_modal_migration_target_move: 'click_main_modal_migration_target_move',
  click_main_modal_migration_info_detail: 'click_main_modal_migration_info_detail',
  click_channel_banner_ai: 'click_channel_banner_ai',
  click_channel_creategame_modal_type: 'click_channel_creategame_modal_type',
  click_channel_ai_failed_project: 'click_channel_ai_failed_project',
  click_newgame_ai_create_bottom: 'click_newgame_ai_create_bottom',
  click_newgame_ai_create_side: 'click_newgame_ai_create_side',
  click_newgame_ai_storyconfirm_edit: 'click_newgame_ai_storyconfirm_edit',
  click_newgame_ai_storyconfirm_edit_save: 'click_newgame_ai_storyconfirm_edit_save',
  click_newgame_ai_storyconfirm_finish: 'click_newgame_ai_storyconfirm_finish',
  click_newgame_ai_styleconfig_create: 'click_newgame_ai_styleconfig_create',
  click_newgame_ai_exit_modal_cancel: 'click_newgame_ai_exit_modal_cancel',
  click_newgame_ai_exit_modal_exit: 'click_newgame_ai_exit_modal_exit',
  click_editgame_theme_mainimage_horizontal_aigenerate:
    'click_editgame_theme_mainimage_horizontal_aigenerate',
  click_editgame_theme_mainimage_vertical_aigenerate:
    'click_editgame_theme_mainimage_vertical_aigenerate',
  click_editgame_theme_backgroundimage_aigenerate:
    'click_editgame_theme_backgroundimage_aigenerate',
  click_editgame_theme_missionbackgroundimage_aigenerate:
    'click_editgame_theme_missionbackgroundimage_aigenerate',
  click_editgame_theme_bgm_aigenerate: 'click_editgame_theme_bgm_aigenerate',
  click_editgame_modal_aigenerate_image: 'click_editgame_modal_aigenerate_image',
  click_editgame_modal_aigenerate_bgm: 'click_editgame_modal_aigenerate_bgm',
  click_editgame_gamesetting_gameintroduction_image_aigenerate:
    'click_editgame_gamesetting_gameintroduction_image_aigenerate',
  click_editgame_mission_missioncardimage_aigenerate:
    'click_editgame_mission_missioncardimage_aigenerate',
  click_editgame_mission_quest_audioplayer_aigenerate:
    'click_editgame_mission_quest_audioplayer_aigenerate',
  click_editgame_mission_quest_gamebgm_aigenerate:
    'click_editgame_mission_quest_gamebgm_aigenerate',
  click_editgame_item_itemmodal_image_aigenerate: 'click_editgame_item_itemmodal_image_aigenerate',
  click_editgame_item_itemmodal_icon_aigenerate: 'click_editgame_item_itemmodal_icon_aigenerate',
  click_channel_ai_creating_project: 'click_channel_ai_creating_project',
  click_newgame_ai_storyconfig_contact: 'click_newgame_ai_storyconfig_contact',
  click_newgame_ai_storyconfig_refresh: 'click_newgame_ai_storyconfig_refresh',
  click_channel_ai_project_delete: 'click_channel_ai_project_delete',
  click_channel_ai_project_delete_modal_delete: 'click_channel_ai_project_delete_modal_delete',
  click_channel_ai_project_delete_modal_cancel: 'click_channel_ai_project_delete_modal_cancel',
  click_landing_plan: 'click_landing_plan',
  click_landing_plan_compare_detail: 'click_landing_plan_compare_detail',
  click_landing_plan_card_free_start: 'click_landing_plan_card_free_start',
  click_landing_plan_card_pro_subscribe: 'click_landing_plan_card_pro_subscribe',
  click_landing_plan_card_enterprise_contact: 'click_landing_plan_card_enterprise_contact',
  click_landing_plan_card_class_detail: 'click_landing_plan_card_class_detail',
  click_landing_plan_banner_enterprise_contact: 'click_landing_plan_banner_enterprise_contact',
  click_landing_plan_banner_class_purchase: 'click_landing_plan_banner_class_purchase',
  click_landing_plan_faq_contact: 'click_landing_plan_faq_contact',
  click_landing_plan_faq_expand: 'click_landing_plan_faq_expand',
  click_landing_service_info: 'click_landing_service_info',
  click_landing_help: 'click_landing_help',
  click_landing_studio_start: 'click_landing_studio_start',
  click_plan_enterprise_form_submit: 'click_plan_enterprise_form_submit',
  click_plan_pro_channel_select: 'click_plan_pro_channel_select',
  click_setting_plan_unsubscribe: 'click_setting_plan_unsubscribe',
  click_setting_plan_unsubscribe_modal_dismiss: 'click_setting_plan_unsubscribe_modal_dismiss',
  click_setting_plan_unsubscribe_modal_next: 'click_setting_plan_unsubscribe_modal_next',
  click_setting_plan_unsubscribe_modal_next_dismiss:
    'click_setting_plan_unsubscribe_modal_next_dismiss',
  click_setting_plan_unsubscribe_modal_next_done: 'click_setting_plan_unsubscribe_modal_next_done',
  click_setting_plan_cancel: 'click_setting_plan_cancel',
  click_setting_plan_cancel_dismiss: 'click_setting_plan_cancel_dismiss',
  click_setting_plan_cancel_contact: 'click_setting_plan_cancel_contact',
  click_newgame_templete_detail: 'click_newgame_templete_detail',
  click_newgame_templete_detail_select: 'click_newgame_templete_detail_select',
  click_channel_leave: 'click_channel_leave',
  click_channel_leave_modal_leave: 'click_channel_leave_modal_leave',
  click_plan_promotion_modal_free: 'click_plan_promotion_modal_free',
  click_plan_promotion_modal_pro: 'click_plan_promotion_modal_pro',
  click_plan_promotion_modal_enterprise: 'click_plan_promotion_modal_enterprise',
  click_plan_promotion_modal_class: 'click_plan_promotion_modal_class',
  click_plan_modal_concurrent_session_existing_dismiss:
    'click_plan_modal_concurrent_session_existing_dismiss',
  click_plan_modal_concurrent_session_incoming_login:
    'click_plan_modal_concurrent_session_incoming_login'
} as const;
export type ClickEventName = typeof ClickEventName[keyof typeof ClickEventName];

export const UploadEventName = {
  upload_editgame_theme_mainimage_horizontal: 'upload_editgame_theme_mainimage_horizontal',
  upload_editgame_theme_mainimage_vertical: 'upload_editgame_theme_mainimage_vertical',
  upload_editgame_theme_backgroundimage_gamebackgroundimage:
    'upload_editgame_theme_backgroundimage_gamebackgroundimage',
  upload_editgame_theme_backgroundimage_missionbackgroundimage:
    'upload_editgame_theme_backgroundimage_missionbackgroundimage',
  upload_editgame_theme_mainbgm: 'upload_editgame_theme_mainbgm',
  upload_editgame_mission_file: 'upload_editgame_mission_file',
  upload_newgame_mainimage: 'upload_newgame_mainimage',
  upload_gamesetting_gameintroduction_previewimage:
    'upload_gamesetting_gameintroduction_previewimage'
} as const;
export type UploadEventName = typeof UploadEventName[keyof typeof UploadEventName];

export const InputEventName = {
  input_editgame_mission_missiondetail: 'input_editgame_mission_missiondetail',
  input_channel_searchgames: 'input_channel_searchgames',
  input_channel_input_feed: 'input_channel_input_feed',
  input_channel_input_community: 'input_channel_input_community',
  input_newgame_name: 'input_newgame_name',
  input_newgame_imagesearch: 'input_newgame_imagesearch',
  input_newgame_description: 'input_newgame_description',
  input_gamesetting_basicinformation_story: 'input_gamesetting_basicinformation_story',
  input_gamesetting_basicinformation_tag: 'input_gamesetting_basicinformation_tag',
  input_gamesetting_gameintroduction_oneline: 'input_gamesetting_gameintroduction_oneline',
  input_gamesetting_gameintroduction_concept: 'input_gamesetting_gameintroduction_concept',
  input_gamesetting_gameintroduction_youtubeurl: 'input_gamesetting_gameintroduction_youtubeurl',
  input_gamesetting_gamedetail_announcement: 'input_gamesetting_gamedetail_announcement',
  input_gamesetting_gamedetail_recommandplayernumber:
    'input_gamesetting_gamedetail_recommandplayernumber',
  input_gamesetting_gamedetail_availableplaytime: 'input_gamesetting_gamedetail_availableplaytime',
  input_gamesetting_gamenotice_etc: 'input_gamesetting_gamenotice_etc',
  input_gamesetting_deleteplayhistory_writegamename:
    'input_gamesetting_deleteplayhistory_writegamename',
  input_releasemanage_ready_readyannouncement: 'input_releasemanage_ready_readyannouncement',
  input_releasemanage_salesetting_payprice: 'input_releasemanage_salesetting_payprice',
  input_releasemanage_salesetting_discountprice: 'input_releasemanage_salesetting_discountprice',
  input_verifycontactpage_phonenumber: 'input_verifycontactpage_phonenumber',
  input_verifycontactpage_checknumber: 'input_verifycontactpage_checknumber',
  input_verifycontactpage_email: 'input_verifycontactpage_email',
  input_newchannelpage_channelname: 'input_newchannelpage_channelname',
  input_newchannelpage_channelsummery: 'input_newchannelpage_channelsummery'
} as const;
export type InputEventName = typeof InputEventName[keyof typeof InputEventName];

export const SaveEventName = {
  save_gamesetting: 'save_gamesetting',
  save_editgame_theme: 'save_editgame_theme',
  save_editgame_mission: 'save_editgame_mission',
  save_editgame_mission_quest: 'save_editgame_mission_quest',
  save_editgame_mission_new_quest: 'save_editgame_mission_new_quest',
  save_editgame_mission_quest_webviewbuilder: 'save_editgame_mission_quest_webviewbuilder'
} as const;

export type SaveEventName = typeof SaveEventName[keyof typeof SaveEventName];

export const GAEventName = {
  page_view: 'page_view'
} as const;
export type GAEventName = typeof GAEventName[keyof typeof GAEventName];

// 프로모션 모달 트리거 위치
export const PromotionTriggerLocation = {
  // 채널 홈
  channel_create: '채널 생성 시',
  content_create_limit_button: '콘텐츠 생성 버튼',
  content_create_limit_sidebar: '채널 홈 사이드 바',
  plan_downgraded: '무료 전환 안내 팝업',

  // 채널 설정 - 구성원 관리
  invite_owner: '소유자 초대 시',
  invite_editor: '편집자 초대 시',
  invite_tester: '테스터 초대 시',

  // 채널 설정 - 요금제/후원
  plan_management: '요금제 관리',
  donation: '후원 및 판매', // 추가 개발 필요

  // AI 크레딧
  ai_credit_insufficient_create: '콘텐츠 생성 AI 크레딧 부족',
  ai_credit_insufficient_edit: '콘텐츠 편집 AI 크레딧 부족',

  // 콘텐츠 생성/편집
  template_detail: '템플릿 자세히보기 팝업',
  content_save_blocked_content_limit: '콘텐츠 저장 불가',
  content_save_blocked_action_usage: '고급 액션 포함 저장 불가',
  advanced_action_usage: '고급 액션 리스트',
  mission_edit_banner: '콘텐츠 미션 편집 상단 배너',

  // 콘텐츠 운영
  sidebar_content_management: '콘텐츠 운영 사이드 바',
  dashboard_mission_completion: '미션별 완료율',
  dashboard_play_time: '플레이 시간',

  // 아이템
  item_limit_exceeded_edit: '아이템 6개 이상일 때 수정 불가',
  item_limit_reached_add: '아이템 5개일 때 새 아이템 추가 시',

  // 콘텐츠 제한
  content_publish_advanced_action: '고급 액션 포함 콘텐츠 공개 시도'
} as const;
export type PromotionTriggerLocation =
  typeof PromotionTriggerLocation[keyof typeof PromotionTriggerLocation];

// 요금제 한글 매핑
export const PLAN_TYPE_KOREAN: Record<Exclude<PlanType, 'Realworld'>, string> = {
  Free: '무료',
  Pro: '프로',
  Teacher: '티처',
  Class: '클래스',
  Enterprise: '엔터프라이즈'
};

export type TrackEventName =
  | PageViewEventName
  | GAEventName
  | ClickEventName
  | UploadEventName
  | InputEventName
  | SaveEventName;

const TrackEventNameToGAPageView: Record<PageViewEventName, { title: string }> = {
  view_landing: {
    title: '랜딩페이지'
  },
  view_channel_createdgames: {
    title: '만든 게임 목록'
  },
  view_channel_feed: {
    title: '피드'
  },
  view_community: {
    title: '커뮤니티'
  },
  view_channel_setting: {
    title: '채널설정'
  },
  view_createnewgame: {
    title: '새 게임 만들기'
  },
  view_dashboard: {
    title: '대시보드'
  },
  view_gamesetting: {
    title: '게임설정'
  },
  view_releasemanage: {
    title: '출시관리'
  },
  view_communitymanage: {
    title: '커뮤니티 관리'
  },
  view_editgame_edittheme: {
    title: '테마 편집'
  },
  view_editgame_editmission: {
    title: '미션 편집'
  },
  view_editgame_editmission_quest: {
    title: '미션 편집 쿼스트'
  },
  view_editgame_edititem: {
    title: '아이템 편집'
  },
  view_editgame_editchatbot: {
    title: '챗봇 편집'
  },
  view_editgame_filestorage: {
    title: '파일 보관함'
  },
  view_agreetermpage: {
    title: '이용약관'
  },
  view_verifycontact: {
    title: '연락처 인증'
  },
  view_welcomestudiopage: {
    title: '환영'
  },
  view_onboardingpage: {
    title: '온보딩'
  },
  view_newchannelpage: {
    title: '채널 생성'
  },
  view_newgame_ai_storyconfig: {
    title: 'AI 게임 스토리 설정'
  },
  view_newgame_ai_storyconfig_error: {
    title: 'AI 게임 스토리 설정 오류'
  },
  view_newgame_ai_storyconfig_refresh: {
    title: 'AI 게임 스토리 설정 새로고침'
  },
  view_newgame_ai_storyconfirm: {
    title: 'AI 게임 스토리 확인'
  },
  view_newgame_ai_styleconfig: {
    title: 'AI 게임 스타일 설정'
  },
  view_newgame_ai_exit_modal: {
    title: 'AI 게임 생성 종료 모달'
  },
  view_editgame_modal_aigenerate_image: {
    title: 'AI 이미지 생성 모달'
  },
  view_editgame_modal_aigenerate_bgm: {
    title: 'AI BGM 생성 모달'
  },
  view_landing_plan: {
    title: '랜딩페이지 요금제'
  },
  view_landing_service_info: {
    title: '랜딩페이지 서비스 소개'
  },
  view_plan_enterprise_form: {
    title: '랜딩 페이지 엔터프라이즈 문의'
  },
  view_plan_enterprise_form_submit_success: {
    title: '랜딩 페이지 엔터프라이즈 문의 성공'
  },
  view_plan_pro_channel_select: {
    title: '프로 요금제 채널 선택'
  },
  view_setting_channel: {
    title: '채널 설정'
  },
  view_setting_member: {
    title: '구성원 관리'
  },
  view_setting_plan: {
    title: '요금제 관리'
  },
  view_setting_donation: {
    title: '후원 및 판매'
  },
  view_plan_promotion_modal: {
    title: '요금제 프로모션 모달'
  },
  view_plan_modal_concurrent_session_existing: {
    title: '동시 접속 기존 접속자 모달'
  },
  view_plan_modal_concurrent_session_incoming: {
    title: '동시 접속 새로운 접속자 모달'
  }
};

function initialize({ userId }: { userId?: string }) {
  try {
    if (!isDev) {
      window.gtag('js', new Date());
      window.gtag('config', 'G-VBEFHCW62Z', {
        send_page_view: false,
        user_id: userId
      });
    }

    mixpanel.init(
      isDev || isStaging ? '8a279c92d42b21e54ae66d3e9e6c5c29' : '72ab7113942c2efc3a73911379f8f2e0',
      {
        debug: isDev
      }
    );
    if (userId) mixpanel.identify(userId);
  } catch (e) {
    console.error(e);
  }
}

function sendGAEvent(trackEventName: TrackEventName, params?: object) {
  if (isDev) {
    return;
  }
  try {
    window.gtag('event', trackEventName, params);
  } catch (e) {
    console.error(e);
  }
}

function sendMixpanelEvent(trackEventName: TrackEventName, params?: object) {
  try {
    mixpanel.track(trackEventName, params);
  } catch (e) {
    console.error(e);
  }
}

function onPageView({
  pageViewEventName,
  params
}: {
  pageViewEventName: PageViewEventName;
  params?: object;
}) {
  if (isDev) {
    console.log(
      `개발서버에서 pageViewEventName : ${pageViewEventName} (으)로 onPageView가 호출 되었습니다. params: ${JSON.stringify(
        params
      )}`
    );
  }
  try {
    sendGAEvent(GAEventName.page_view, {
      page_title: TrackEventNameToGAPageView[pageViewEventName].title,
      page_location: pageViewEventName
    });
    sendGAEvent(pageViewEventName);
    sendMixpanelEvent(pageViewEventName, params);
  } catch (e) {
    console.error(e);
  }
}

function onPageViewMixpanel(pageViewEventName: PageViewEventName, params?: object) {
  if (isDev) {
    console.log(
      `개발서버에서 pageViewEventName : ${pageViewEventName} (으)로 onPageView가 호출 되었습니다. params: ${JSON.stringify(
        params
      )}`
    );
  }
  try {
    sendMixpanelEvent(pageViewEventName, params);
  } catch (e) {
    console.error(e);
  }
}

function onClick({ clickEventName, params }: { clickEventName: ClickEventName; params?: object }) {
  if (isDev) {
    console.log(
      `개발서버에서 clickEventName : ${clickEventName} (으)로 onClick이 호출 되었습니다. params: ${JSON.stringify(
        params
      )}`
    );
  }
  try {
    sendGAEvent(clickEventName, params);
    sendMixpanelEvent(clickEventName, params);
  } catch (e) {
    console.error(e);
  }
}

function onUpload({
  uploadEventName,
  params
}: {
  uploadEventName: UploadEventName;
  params?: object;
}) {
  if (isDev) {
    console.log(
      `개발서버에서 uploadEventName : ${uploadEventName} (으)로 onUpload가 호출 되었습니다. params: ${JSON.stringify(
        params
      )}`
    );
  }
  try {
    sendGAEvent(uploadEventName, params);
    sendMixpanelEvent(uploadEventName, params);
  } catch (e) {
    console.error(e);
  }
}

function onInput({ inputEventName, params }: { inputEventName: InputEventName; params?: object }) {
  if (isDev) {
    console.log(
      `개발서버에서 inputEventName : ${inputEventName} (으)로 onInput가 호출 되었습니다. params: ${JSON.stringify(
        params
      )}`
    );
  }
  try {
    sendGAEvent(inputEventName, params);
    sendMixpanelEvent(inputEventName, params);
  } catch (e) {
    console.error(e);
  }
}

function onSave({ saveEventName, params }: { saveEventName: SaveEventName; params?: object }) {
  if (isDev) {
    console.log(
      `개발서버에서 saveEventName : ${saveEventName} (으)로 onSave가 호출 되었습니다. params: ${JSON.stringify(
        params
      )}`
    );
  }
  try {
    sendGAEvent(saveEventName, params);
    sendMixpanelEvent(saveEventName, params);
  } catch (e) {
    console.error(e);
  }
}

const onInputThrottled: typeof onInput = throttleFn(onInput, 5000);

export const track = {
  initialize,
  onPageView,
  onPageViewMixpanel,
  onClick,
  onUpload,
  onInput,
  onInputThrottled,
  onSave
};
